const setThreadContextWindowUsage = ({ threadId, contextWindowUsage } = {}) => {
  return {
    type: 'pieveSetThreadContextWindowUsage',
    payload: { threadId, contextWindowUsage }
  };
};

export default setThreadContextWindowUsage;
